<script>
import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
import BlockTitle from "@/components/blocks/BlockTitle";
import ProductNewsCard from "@/components/cards/ProductNewsCard";
import AlertsCard from "@/components/cards/AlertsCard";
import SericeStatusCard from "@/components/cards/SericeStatusCard";
import FeedbackCard from "@/components/cards/FeedbackCard";
import PracticeAdminCard from "@/components/cards/PracticeAdminCard";
import appConfig from "@/app.config";
import {
  // meetingsAndEvents,
  // meetingsMinutes,
  // news,
  // videos,
  staffMembers,
  keyTopics,
  keyPathways,
  keyServices,
  prescribingGuidelines,
  sharedCareGuidelines,
} from "./data.js";
import api from "../../../api";

export default {
  page: {
    title: "Home",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Heading,
    BlockTitle,
    ProductNewsCard,
    AlertsCard,
    SericeStatusCard,
    FeedbackCard,
    PracticeAdminCard,
  },
  data() {
    return {
      page: {
        title: "",
        lastUpdated: "31 Dec 2020 15:00",
        addNewBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
      },
      screenWidth: 1440,
      meetingsAndEvents: [],
      meetingsAndEventsCatId: null,
      videos: [],
      videosCatId: [],
      staffMembers: staffMembers,
      keyTopics: keyTopics,
      keyPathways: keyPathways,
      keyServices: keyServices,
      prescribingGuidelines: prescribingGuidelines,
      sharedCareGuidelines: sharedCareGuidelines,
      categoriesList: [],
      productNewsList: [],
    };
  },
  computed: {
    prdouctNewsCategory() {
      return (
        this.categoriesList.find((cat) => cat.name == "Product News") || null
      );
    },
    eventsToShow() {
      return [
        {
          id: 1234234234,
          title: "Board Meeting",
          description:
            "Lorem ipsum dolor sit amet, consect adipiscing elit. Morbi in finibus mauris, eu varius mauris. Sed luctus ipsum non varius placerat.",
          additionalProp1: {
            data: "",
            start_time: 10000000,
            end_time: 134435,
          },
        },
        {
          id: 12345634234,
          title: "Scheduled Training",
          description:
            "Mandatory Bluestream Training for all new staff members",
          additionalProp1: {
            data: "",
            start_time: 10000000,
            end_time: 134435,
          },
        },
      ];
    },
  },
  methods: {
    async getProductPages() {
      if (this.prdouctNewsCategory?.id) {
        let { data } = await api.get(
          "/api/categories/" + this.prdouctNewsCategory.id + "/pages"
        );
        console.log("response", data);
        this.productNewsList = data;
      }
    },
    async getPcnWithRels() {
      if (
        this.currentPractice &&
        Object.prototype.hasOwnProperty.call(this.currentPractice, "pcnId")
      ) {
        await api
          .get(`/api/pcns/${this.currentPcn.id}/practice-data`)
          .then((response) => {
            api
              .get(`/api/practice-data/${response.data.id}/cms`)
              .then((response2) => {
                api
                  .get(`/api/cms/${response2.data.id}/categories`)
                  .then((response3) => {
                    this.categoriesList = response3.data;
                    this.getMeetingsAndEvents();
                    this.getStaffMembers();
                    this.getMeetingsMinutes();
                    this.getMemberPractices();
                    this.getNews();
                    this.getVideos();
                    this.getProductPages();
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.categoriesList = [];
      }
    },
    getMeetingsAndEvents() {
      var catId = this.categoriesList.filter(
        (cat) => cat.name == "Meeting & Events"
      )[0].id;
      this.meetingsAndEventsCatId = catId;
      api
        .get("/api/categories/" + catId + "/pages")
        .then((response) => {
          this.meetingsAndEvents = response.data.filter(
            (event) => event.active
          );
          console.log(this.meetingsAndEvents);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getStaffMembers() {
      var catId = this.categoriesList.filter((cat) => cat.name == "Staff")[0]
        .id;
      this.staffId = catId;
      api
        .get("/api/categories/" + catId + "/pages")
        .then((response) => {
          this.staff = response.data.filter((event) => event.active);
          console.log(this.staff);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getMeetingsMinutes() {
      var catId = this.categoriesList.filter(
        (cat) => cat.name == "Meeting Minutes"
      )[0].id;
      api
        .get("/api/categories/" + catId + "/pages")
        .then((response) => {
          this.meetingsMinutes = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getMemberPractices() {
      var catId = this.categoriesList.filter(
        (cat) => cat.name == "Member Practices"
      )[0].id;
      api
        .get("/api/categories/" + catId + "/pages")
        .then((response) => {
          this.memberPractices = response.data.filter(
            (practice) => practice.active
          );
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getNews() {
      var catId = this.categoriesList.filter((cat) => cat.name == "News")[0].id;
      this.newsCatId = catId;
      api
        .get("/api/categories/" + catId + "/pages")
        .then((response) => {
          const sortednews = response.data.some(
            (page) => page.additionalProp1.position
          )
            ? response.data.sort(
                (a, b) =>
                  a.additionalProp1.position - b.additionalProp1.position
              )
            : response.data;
          const filteredNews = sortednews.filter(
            (item) => item.additionalProp1.featured
          );
          this.news = filteredNews;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getVideos() {
      var catId = this.categoriesList.filter((cat) => cat.name == "Videos")[0]
        .id;
      this.videosCatId = catId;
      api
        .get("/api/categories/" + catId + "/pages")
        .then((response) => {
          this.videos = response.data.filter(
            (video) => video.additionalProp1.featured_video
          );
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getScreenWidth() {
      return window.innerWidth;
    },
    getChunksArray(inputArray, chunks) {
      const chunksArray = inputArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / chunks);
        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [];
        }
        resultArray[chunkIndex].push(item);
        return resultArray;
      }, []);
      return chunksArray;
    },
    getCurrentSlideIndex(event) {
      console.log("CurrentSlideIndex");
      console.log(event);
    },
    onMinnuteClick(card) {
      const url = card.additionalProp1.file_url;
      window.open(url, "_blank");
    },
    onNewsClick(card) {
      console.log(`go to  newsitem ${card.id}`);
    },
    onEventClick(card) {
      console.log(`add to calendar event ${card.id}`);
    },
    onVideoClick(card) {
      console.log(`play video ${card.id}`);
    },
    onStaffClick(card) {
      console.log(`show staff ${card.id}`);
    },
    onPracticeClick(card) {
      if (!card.additionalProp1.website_url) return;
      let url = card.additionalProp1.website_url;
      if (!url.startsWith("http")) {
        url = "https://" + url;
      }
      window.open(url, "_blank");
    },
    onOptionSelected(selectedOption) {
      this.$router.push(selectedOption.link);
    },
    onTabClick(tab) {
      this.$router.push(`/pcn/pcn-staff?tab=${tab.name}`);
    },
  },
  watch: {
    currentPcn() {
      this.getPcnWithRels();
      console.log("currentPcn", this.currentPcn);
      this.page.title = this.currentPcn?.name
        ? `Welcome to Frimley PCN`
        : "Welcome to PCN 5";
    },
  },
  beforeMount() {
    this.screenWidth = this.getScreenWidth();
  },
  async mounted() {
    await this.getPcnWithRels();
    window.addEventListener("resize", () => {
      this.screenWidth = this.getScreenWidth();
    });
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.screenWidth = this.getScreenWidth();
    });
  },
};
</script>

<template>
  <Layout>
    <Heading :page="page"></Heading>
    <div class="banner">
      <img
        :src="require('@/assets/images/pcn-home-banner.png')"
        alt="pcn-home-banner"
      />
    </div>
    <div class="pcn-container">
      <div class="pcn-cards">
        <div class="pcn-cards-row row p-0">
          <div class="pcn-block pcn-block__meetings col-6">
            <block-title title="Product News">
              <router-link
                :to="`/pages/productnews/view-all-page/${prdouctNewsCategory.id}`"
                class="block-link"
                :style="{ color: '#005eb8' }"
                >View All</router-link
              >
            </block-title>
            <div class="pcn-block-container">
              <ProductNewsCard
                v-for="card in productNewsList.slice(0, 2)"
                :key="card.id"
                type="event"
                :id="card.id"
                :borderColor="'#005eb8'"
                :date="card.date"
                :title="card.title"
                :text="card.description"
                @card-click="onEventClick(card)"
              />
            </div>
          </div>
          <div class="pcn-block pcn-block__meetings col-3">
            <block-title title="Alerts">
              <router-link
                :to="`/pages/productnews/view-all-page/${prdouctNewsCategory.id}`"
                class="block-link"
                :style="{ color: '#f35022' }"
                >View All</router-link
              >
            </block-title>
            <div class="alert-card pcn-block-container">
              <AlertsCard
                v-for="card in productNewsList.slice(0, 2)"
                :key="card.id"
                type="event"
                :id="card.id"
                :borderColor="'##d84730'"
                :date="card.date"
                :title="card.title"
                :text="card.description"
                @card-click="onEventClick(card)"
              />
            </div>
          </div>
          <div class="pcn-block pcn-block__meetings col-3">
            <block-title title="Happiness Meter"> </block-title>
            <div class="pcn-block-container">
              <FeedbackCard></FeedbackCard>
            </div>
          </div>
          <div class="pcn-block pcn-block__meetings col-6">
            <block-title title="ICB Updates">
              <router-link
                :to="`/pages/productnews/view-all-page/${prdouctNewsCategory.id}`"
                class="block-link"
                :style="{ color: '#715bff' }"
                >View All</router-link
              >
            </block-title>
            <div class="pcn-block-container">
              <ProductNewsCard
                v-for="card in productNewsList.slice(0, 2)"
                :key="card.id"
                type="event"
                :id="card.id"
                :borderColor="'#715bff'"
                :date="card.date"
                :title="card.title"
                :text="card.description"
                @card-click="onEventClick(card)"
              />
            </div>
          </div>
          <div class="pcn-block pcn-block__meetings col-3">
            <block-title title="Service Status"> </block-title>
            <div class="pcn-block-container">
              <SericeStatusCard type="event" :borderColor="'#715bff'" />
            </div>
          </div>
          <div class="pcn-block pcn-block__meetings col-3">
            <block-title title="Practice Admins"> </block-title>
            <div class="pcn-block-container">
              <PracticeAdminCard></PracticeAdminCard>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
